/* import __COLOCATED_TEMPLATE__ from './signup-checkbox.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import clsx from 'clsx';

/** @module */
class SignupCheckboxComponent extends Component {
  get classNames() {
    return clsx(
      this.args.class,
      'signup-checkbox',
      this.args.error && 'signup-checkbox--error',
    );
  }

  get inputClassNames() {
    return clsx('filled-in', this.args.error && 'invalid');
  }

  get hasError() {
    return Boolean(this.args.error);
  }

  /**
   * @param {MouseEvent|KeyboardEvent} e
   */
  @action
  handleOnClick(e) {
    e.preventDefault();

    if (!this.args.disabled) {
      this.args.onclick();
    }
  }

  /**
   * @param {KeyboardEvent} e
   */
  @action
  handleKeyDown(e) {
    switch (e.key) {
      case 'Space':
      case 'Enter':
        this.handleOnClick(e);
        break;
    }
  }
}

export default SignupCheckboxComponent;
